import React from 'react';

import { Column, Text } from 'farmhub-ui-core';

import { TitleElectronicBillSkeleton } from 'components/Skeleton';

type TitleElectronicBillProps = {
  title: string;
  subTitle: string;
  isLoading: boolean;
  isPrint?: boolean;
  isCart?: boolean;
};

const TitleElectronicBill = ({
  title,
  subTitle,
  isLoading,
  isCart = false,
  isPrint = false,
}: TitleElectronicBillProps) => {
  if (isLoading) {
    return <TitleElectronicBillSkeleton />;
  }

  return (
    <Column alignItems="center" styles={{ gap: 6, padding: '36px 0px' }}>
      <Text color={isPrint ? 'black' : 'dark'} size="lg" weight="bold">
        {title}
      </Text>
      {!isCart && (
        <Text color={isPrint ? 'black' : 'secondary'}>{subTitle}</Text>
      )}
    </Column>
  );
};

export default TitleElectronicBill;
